import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../shared/vars'

import axios from 'axios';
import { isEmpty } from 'lodash'

const countryCheck = async () => {
    const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }

    // Request to grab user's country from the backend
    let loc = await axios.get(REACT_APP_API_URL + 'locations/country', { headers: AUTH_HEADER })
    .then((response) => {
        if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
            // Return null as to not interfere with site & cause error if an error occurs
            console.log('Unable to locate');
            return null;
        } else {
            // Return country code
            return response.data.country;
        }
    })
    .catch((err) => {
        // Return null as to not interfere with site & cause error if an error occurs
        console.log(err.message);
        return null;
    });

    // If location was in fact returned & the user's country is in fact Canada
    if(!isEmpty(loc) && loc === 'CA') {
        return true;
    } else {
        return false;
    }
};

export default countryCheck;


// WEBPACK FOOTER //
// ./src/utils/countryCheck.js